<div class="department-search-wrapper">
  <adm-text-search [placeholder]="'Søg efter afdeling'" (search$)="onSearch($event)" />
  <button (click)="resetFilter()" class="actions__reset" mat-stroked-button>Nulstil</button>
</div>
<ok-card [loading]="organizationDetails()?.loading() ?? true">
  <adm-organization-details
    [organization]="organizationDisplay()"
    [isCustomerEntranceDialog]="true"
    [departmentFilter]="departmentFilter()"
    (linkNavigated)="closeDialogRequested.emit()" />
</ok-card>
